// Lib
import { isEmpty, difference, repeat } from 'lodash/fp';

// Utils
import { getDomElementId } from '../../../element/utils/elementUtil';
import {
    getElementId,
    getElementType,
    getFilename,
    getFileUrl,
    getTitle,
} from '../../../../common/elements/utils/elementPropertyUtils';

// Constants
import { ElementType } from '../../../../common/elements/elementTypes';

const getCaptionClipboardHtml = (domNode) => {
    const captionTextNode = domNode.querySelector(
        '.Caption .DraftEditor-root div[data-contents=true], .Caption .tiptap',
    );
    if (!captionTextNode) return;

    return `<hr/><div style="font-size: 0.9em;">${captionTextNode.innerHTML}</div>`;
};

const getCardClipboardHtml = (element) => {
    const elementId = getElementId(element);
    const elementDomId = getDomElementId(elementId);

    const domNode = document.getElementById(elementDomId);

    if (!domNode) return;

    let domContentsStr = '';

    const bodyTextNode = domNode.querySelector(
        '.CardEditor .DraftEditor-root div[data-contents=true], .CardTiptapEditor .tiptap',
    );
    if (bodyTextNode) {
        domContentsStr = `${domContentsStr}${bodyTextNode.innerHTML}`;
    }

    const captionText = getCaptionClipboardHtml(domNode);

    if (captionText) {
        domContentsStr = `${domContentsStr}${captionText}`;
    }

    return !isEmpty(domContentsStr) ? domContentsStr : undefined;
};

const getElementInnerHtml = (element) => {
    const elementId = getElementId(element);
    const elementDomId = getDomElementId(elementId);

    const domNode = document.getElementById(elementDomId);

    if (!domNode) return;

    return domNode.innerHTML;
};

const getBoardClipboardHtml = (element) => {
    const title = getTitle(element);
    return `<div><h1>${title}</h1></div>`;
};

const getColumnClipboardHtml = (element) => {
    const elementId = getElementId(element);
    const elementDomId = getDomElementId(elementId);

    const domNode = document.getElementById(elementDomId);
    if (!domNode) return;

    const listDomNode = domNode.querySelector('.List');
    if (!listDomNode) return;

    const title = getTitle(element);
    return `<div><h2>${title}</h2>${listDomNode.innerHTML}</div>`;
};

const getImmediateTasks = (domNode, depth) => {
    const allTasks = domNode.querySelectorAll('.ListContainer .Task');

    if (isEmpty(allTasks)) return;

    // The selector will match based on the document for elements inside the domNode down
    // So we need to repeat '.ListContainer' so that immediate sub-tasks are excluded from this match
    const allSubTasks = domNode.querySelectorAll(`${repeat(depth, '.ListContainer ')} .ListContainer .Task`);

    return difference(allTasks, allSubTasks);
};

const getTasksListHtml = (domNode, depth = 1) => {
    const immediateTasks = getImmediateTasks(domNode, depth);

    if (!immediateTasks) return '';

    return `<ul>${immediateTasks
        .map((taskNode) => {
            const textNode = taskNode.querySelector(
                '.TaskDraftJsEditor .DraftEditor-root div[data-contents=true] .public-DraftStyleDefault-block, .tiptap',
            );
            return `<li>${textNode && textNode.innerHTML}${getTasksListHtml(taskNode, depth + 1)}</li>`;
        })
        .join('')}</ul>`;
};

const getTaskListClipboardHtml = (element) => {
    const elementId = getElementId(element);
    const elementDomId = getDomElementId(elementId);

    const domNode = document.getElementById(elementDomId);

    const title = getTitle(element);
    const titleHtml = title ? `<h2>${title}</h2>` : '';

    return `<div>${titleHtml}${getTasksListHtml(domNode)}</div>`;
};

const getFileClipboardHtml = (element) => `<a href="${getFileUrl(element)}">${getFilename(element)}</a>`;

export default (element) => {
    const elementType = getElementType(element);

    switch (elementType) {
        case ElementType.CARD_TYPE:
            return getCardClipboardHtml(element);
        case ElementType.BOARD_TYPE:
            return getBoardClipboardHtml(element);
        case ElementType.COLUMN_TYPE:
            return getColumnClipboardHtml(element);
        case ElementType.IMAGE_TYPE:
        case ElementType.LINK_TYPE:
            return getElementInnerHtml(element);
        case ElementType.TASK_LIST_TYPE:
            return getTaskListClipboardHtml(element);
        case ElementType.FILE_TYPE:
            return getFileClipboardHtml(element);
        default:
            return null;
    }
};
